import React, { useEffect } from 'react'
import Typewriter from 'typewriter-effect'
import Image from 'next/image'
import usePageContext from '../../Page/context'

const textSmallBaseStyle = 'font-swinton font-normal text-[19px] leading-none tracking-[-0.05em]'

const Desktop = (props: any) => {
  // Theme
  const { dispatch } = usePageContext()

  const [isThemeSet, setIsThemeSet] = React.useState(false)

  useEffect(() => {
    if (!isThemeSet) {
      dispatch({
        type: 'SET_THEME',
        payload: 'black'
      })
      setIsThemeSet(true)
    }
  }, [isThemeSet, dispatch])

  return (
    <div className='pt-[200px]'>
      <div className='flex flex-col items-center'>
        <div className='w-full lg:w-2/3 2xl:w-1/2 flex flex-col items-center'>
          <div className='small-texts w-full bg-white'>
            <div className='flex justify-center'>
              <div className='w-1/3 flex justify-center items-center'>
                <div className={textSmallBaseStyle}>{props.headerTextLeft}</div>
              </div>
              <div className='w-1/3 flex justify-center items-center'>
                <div className={textSmallBaseStyle}>{props.headerTextCenter}</div>
              </div>
              <div className='w-1/3 flex justify-center items-center'>
                <div className={textSmallBaseStyle}>{props.headerTextRight}</div>
              </div>
            </div>
          </div>
          <div
            className={`text-center uppercase font-abcd font-extrabold text-[102.3px] leading-[78%] tracking-[-0.05em] mb-[100px] -mt-[6px]`}
          >
            <Typewriter
              onInit={(typewriter) => {
                typewriter.typeString(props.headerLargeText).start()
              }}
            />
          </div>
        </div>
      </div>
      <div className='flex flex-col items-center w-full space-y-[-2px] font-sans text-[#1E1E1E]'>
        <div className='flex flex-col items-center w-full gap-[100px] px-4'>
          <div className='flex flex-col items-center gap-[100px]'>
            <h2 className='text-[40px] font-bold leading-[0.85] text-center uppercase whitespace-pre-line font-abcd'>
              {props.awardCategoryMainText}
            </h2>
            <p className='text-[19px] leading-[1] tracking-[-0.05em] text-center max-w-3xl font-swinton'>
              {props.awardCategorySubText}
            </p>
            <div className='flex flex-col w-full gap-[50px] mb-[100px]'>
              {/* Row 1 */}
              <div className='flex flex-row w-full justify-between gap-[28px]'>
                <div className='flex-1 min-w-0'>
                  <h3 className='text-[40px] font-bold uppercase tracking-[-0.05em] leading-[1] mb-0 font-abcd' data-labelname='awardCategory1'>
                    {props.awardCategory1}
                  </h3>
                  <p className='text-[19px] font-normal tracking-[-0.05em] leading-[1] font-swinton' data-labelname='awardCategory1Brief'>
                    {props.awardCategory1Brief}
                  </p>
                </div>
                <div className='flex-1 min-w-0'>
                  <h3 className='text-[40px] font-bold uppercase tracking-[-0.05em] leading-[1] mb-0 font-abcd' data-labelname='awardCategory2'>
                    {props.awardCategory2}
                  </h3>
                  <p className='text-[19px] font-normal tracking-[-0.05em] leading-[1] font-swinton' data-labelname='awardCategory2Brief'>
                    {props.awardCategory2Brief}
                  </p>
                </div>
                <div className='flex-1 min-w-0'>
                  <h3 className='text-[40px] font-bold uppercase tracking-[-0.05em] leading-[1] mb-0 font-abcd' data-labelname='awardCategory3'>
                    {props.awardCategory3}
                  </h3>
                  <p className='text-[19px] font-normal tracking-[-0.05em] leading-[1] font-swinton' data-labelname='awardCategory3Brief'>
                    {props.awardCategory3Brief}
                  </p>
                </div>
              </div>
              {/* Row 2 */}
              <div className='flex flex-row w-full justify-between gap-[28px]'>
                <div className='flex-1 min-w-0'>
                  <h3 className='text-[40px] font-bold uppercase tracking-[-0.05em] leading-[1] mb-0 font-abcd' data-labelname='awardCategory4'>
                    {props.awardCategory4}
                  </h3>
                  <p className='text-[19px] font-normal tracking-[-0.05em] leading-[1] font-swinton' data-labelname='awardCategory4Brief'>
                    {props.awardCategory4Brief}
                  </p>
                </div>
                <div className='flex-1 min-w-0'>
                  <h3 className='text-[40px] font-bold uppercase tracking-[-0.05em] leading-[1] mb-0 font-abcd' data-labelname='awardCategory5'>
                    {props.awardCategory5}
                  </h3>
                  <p className='text-[19px] font-normal tracking-[-0.05em] leading-[1] font-swinton' data-labelname='awardCategory5Brief'>
                    {props.awardCategory5Brief}
                  </p>
                </div>
                <div className='flex-1 min-w-0'>
                  <h3 className='text-[40px] font-bold uppercase tracking-[-0.05em] leading-[1] mb-0 font-abcd' data-labelname='awardCategory6'>
                    {props.awardCategory6}
                  </h3>
                  <p className='text-[19px] font-normal tracking-[-0.05em] leading-[1] font-swinton'>
                    {props.awardCategory6Brief}
                  </p>
                </div>
              </div>
              {/* Row 3 */}
              <div className='flex flex-row w-full justify-between gap-[28px]'>
                <div className='flex-1 min-w-0'>
                  <h3 className='text-[40px] font-bold uppercase tracking-[-0.05em] leading-[1] mb-0 font-abcd' data-labelname='awardCategory7'>
                    {props.awardCategory7}
                  </h3>
                  <p className='text-[19px] font-normal tracking-[-0.05em] leading-[1] font-swinton' data-labelname='awardCategory7Brief'>
                    {props.awardCategory7Brief}
                  </p>
                </div>
                <div className='flex-1 min-w-0'>
                  <h3 className='text-[40px] font-bold uppercase tracking-[-0.05em] leading-[1] mb-0 font-abcd' data-labelname='awardCategory8'>
                    {props.awardCategory8}
                  </h3>
                  <p className='text-[19px] font-normal tracking-[-0.05em] leading-[1] font-swinton' data-labelname='awardCategory8Brief'>
                    {props.awardCategory8Brief}
                  </p>
                </div>
                <div className='flex-1 min-w-0'>
                  <h3 className='text-[40px] font-bold uppercase tracking-[-0.05em] leading-[1] mb-0 font-abcd' data-labelname='awardCategory9'>
                    {props.awardCategory9}
                  </h3>
                  <p className='text-[19px] font-normal tracking-[-0.05em] leading-[1] font-swinton' data-labelname='awardCategory9Brief'>
                    {props.awardCategory9Brief}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Section 1: Prizes */}
        <React.Fragment key={1}>
          {props.image1?.data?.attributes?.url &&
            <div className='w-full aspect-[726/395] relative'>
              <Image
                src={`https://dza2a2ql7zktf.cloudfront.net/binaries-cdn/dqzqcuqf9/image/fetch/f_auto/${props.image1?.data?.attributes?.url}`}
                alt='Art Basel Awards going, BEYOND recognition'
                layout='fill'
                objectFit='cover'
              />
            </div>
          }
          <div className='flex flex-col items-center w-full gap-[100px] px-4'>
            <div className='flex flex-col items-center w-full gap-[100px] text-center'>
              <h2 className='mt-[100px] text-[40px] font-[800] leading-[0.8] tracking-[-0.05em] uppercase whitespace-pre-line font-abcd max-w-xl'>
                {props.awardRecognitionMainText}
              </h2>
              <p className='mb-24 text-[19px] leading-[1] tracking-[-0.05em] max-w-4xl font-swinton'>
                {props.awardRecognitionSubText}
              </p>
            </div>
          </div>
        </React.Fragment>

        {/* Section 2: Key Dates */}
        <React.Fragment key={2}>
          {props.image2?.data?.attributes?.url &&
            <div className='w-full aspect-[726/395] relative'>
              <Image
                src={`https://dza2a2ql7zktf.cloudfront.net/binaries-cdn/dqzqcuqf9/image/fetch/f_auto/${props.image2?.data?.attributes?.url}`}
                alt={props.keyDatesMainText}
                layout='fill'
                objectFit='cover'
              />
            </div>
          }
          <div className='flex flex-col items-center w-full gap-[100px] px-4'>
            <div className='flex flex-col items-center w-full gap-[100px] text-center'>
              <h2 className='mt-[100px] text-[40px] font-[800] leading-[0.8] tracking-[-0.05em] uppercase whitespace-pre-line font-abcd'>
                {props.keyDatesMainText}
              </h2>
              <div className='w-full mb-[100px]'>
                <div className='flex flex-row w-full justify-between items-start gap-[28px] font-abcd'>
                  <div className='text-left'>
                    <p className='text-[40px] font-[800] leading-[0.8] tracking-[-0.05em] uppercase whitespace-pre-line'>
                      {props.awardEvent1}
                      <br />
                      {props.awardEvent2}
                      <br />
                      {props.awardEvent3}
                    </p>
                  </div>
                  <div className='text-right'>
                    <p className='text-[40px] font-[800] leading-[0.8] tracking-[-0.05em] uppercase whitespace-pre-line'>
                      {props.awardEvent1Date}
                      <br />
                      {props.awardEvent2Date}
                      <br />
                      {props.awardEvent3Date}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </React.Fragment>

        {/* Section 3: Judging Process */}
        <React.Fragment key={3}>
          {props.image3?.data?.attributes?.url &&
            <div className='w-full aspect-[726/395] relative'>
              <Image
                src={`https://dza2a2ql7zktf.cloudfront.net/binaries-cdn/dqzqcuqf9/image/fetch/f_auto/${props.image3?.data?.attributes?.url}`}
                alt={props.judgingProcessHeading}
                layout='fill'
                objectFit='cover'
              />
            </div>
          }
          <div className='flex flex-col items-center w-full gap-[100px] pb-16 px-4'>
            <div className='flex flex-col items-center w-full gap-[100px] text-center'>
              <h2 className='mt-[100px] text-[40px] font-[800] leading-[0.8] tracking-[-0.05em] uppercase whitespace-pre-line font-abcd'>
                {props.judgingProcessHeading}
              </h2>
              <div className='w-full'>
                <div className='flex flex-row w-full justify-between text-left gap-[28px]'>
                  <div key='jp-stage1' className='flex-1 min-w-0'>
                    <h3 className='whitespace-pre-line text-[40px] font-[800] uppercase tracking-[-0.03em] leading-[0.8] mb-2 whitespace-pre-line font-abcd'>
                      {props.stageOneHeading}
                    </h3>
                    <p className='text-[19px] font-normal tracking-[-0.05em] leading-[1] font-swinton'>
                      {props.stageOneSubHeading}
                    </p>
                  </div>
                  <div key='291:1189' className='flex-1 min-w-0'>
                    <h3 className='whitespace-pre-line text-[40px] font-[800] uppercase tracking-[-0.03em] leading-[0.8] mb-2 whitespace-pre-line font-abcd'>
                      {props.stageTwoHeading}
                    </h3>
                    <p className='text-[19px] font-normal tracking-[-0.05em] leading-[1] font-swinton'>
                      {props.stageTwoSubHeading}
                    </p>
                  </div>
                  <div key='291:1191' className='flex-1 min-w-0'>
                    <h3 className='whitespace-pre-line text-[40px] font-[800] uppercase tracking-[-0.03em] leading-[0.8] mb-2 whitespace-pre-line font-abcd'>
                      {props.stageThreeHeading}
                    </h3>
                    <p className='text-[19px] font-normal tracking-[-0.05em] leading-[1] font-swinton'>
                      {props.stageThreeSubHeading}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </React.Fragment>
      </div>
    </div>
  )
}

export default Desktop
